import { ApproximateCardLayout } from "../ApproximateCardLayout/ApproximateCardLayout";
import React, { FC } from "react";
import { Trans } from "react-i18next";

/**
 * Etapa 1: Leitura do cartão.
 * Usa o mesmo layout da gravação; a leitura inicia automaticamente.
 * Se houver erro, exibe o botão "Tentar novamente".
 */
export interface CashlessOfflineRechargeCardLayoutProps {
  showRetryButton?: boolean;
  onRetry?: () => void;  
  line1: string;
  line2: string;
}

export const CashlessOfflineRechargeCardLayout: FC<CashlessOfflineRechargeCardLayoutProps> = ({
  showRetryButton,
  onRetry,
  line1,
  line2,
}) => (
  <ApproximateCardLayout
    line1={
      <Trans i18nKey="offline_recharge.read.line1">
        {" "}
        <b>Para começar,</b> aproxime
      </Trans>
    }
    line2={
      <Trans i18nKey="offline_recharge.read.line2">
        seu <b>cartão/pulseira</b>
      </Trans>
    }
    showRetryButton={showRetryButton}
    onRetry={onRetry}
  />
);
